var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F33052"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M244.128,201.808l-28.992,108.368h-30.4l-15.072-55.584c-1.376-5.024-2.992-11.744-4.848-20.176 l-1.52-6.656h-0.704l-1.6,6.752l-1.504,6.656c-1.12,4.496-2.32,8.992-3.584,13.504l-15.488,55.504h-30.08L82.24,201.808h20.96 l15.648,59.472c0.96,3.808,2.144,9.072,3.584,15.792l1.664,7.936l1.6,7.936h0.72c0.848-3.488,1.488-6.144,1.904-7.936l1.904-7.856 c0.992-4.128,2.4-9.392,4.208-15.792l16.672-59.552h24.144l16.272,59.552c1.376,5.072,2.736,10.336,4.048,15.792l1.824,7.856 l1.904,7.936h0.64l1.744-7.936l1.664-7.936c1.376-6.4,2.624-11.696,3.728-15.872l16.032-59.392L244.128,201.808L244.128,201.808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M272.16,219.12v27.936h50.8v15.168h-50.8v30.64h54.064v17.312H251.6V201.808h74.144v17.312 L272.16,219.12L272.16,219.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M341.552,310.192V201.824h53.264c12.48,0,20.992,2,25.536,6c4.512,4,6.784,11.52,6.784,22.576 c0,13.392-5.312,21.28-15.952,23.664v0.4c12.368,1.904,18.576,10.496,18.576,25.792c0,11.056-2.384,18.816-7.152,23.264 c-4.752,4.432-13.056,6.672-24.928,6.672H341.552z M362.112,247.312h25.152c8.16,0,13.36-0.912,15.616-2.704 s3.376-5.952,3.376-12.464c0-8.672-4.928-13.008-14.768-13.008h-29.376V247.312z M362.112,292.88h22.544l7.216-0.16 c6.944,0,11.504-0.992,13.696-2.944c2.192-1.952,3.28-6.096,3.28-12.384c0-6.56-1.136-10.688-3.456-12.368 c-2.304-1.696-7.968-2.544-17.008-2.544h-26.288v30.4H362.112z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.d819a6e15eee114b04a084ce71193e93.svg";
export { ForwardRef as ReactComponent };